<template>
	<div>
		
	</div>
</template>

<script>
	export default {
		name: 'DocsQueryDatasets',
		data() {
			return {
				page: {
					errors: [],
					loading: false,
					showLogin: false
				}
			}
		}
	}
</script>
